export default "__VITE_ASSET__DG5GdFy3__"